var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.5C4.25917 19.5 0 15.2408 0 10C0 4.75917 4.25917 0.5 9.5 0.5C14.7408 0.5 19 4.75917 19 10C19 15.2408 14.7408 19.5 9.5 19.5ZM14.25 10.855L11.6375 9.34292L12.6904 6.1525L12.0967 5.74083L9.51583 7.73583L6.92708 5.73292L6.35708 6.16042L7.38625 9.39042L4.75792 10.855V11.5833H8.20167L9.13583 15.1458H9.90375L10.8379 11.5833H14.2658V10.855H14.25Z",
    fill: "#E5C25B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.4f08aa39e6bcbf18f9f5f034f0189fef.svg";
export { ForwardRef as ReactComponent };